<template>
	<div class="app-field">
		<select
			:id
			v-model="modelValue"
			:disabled
			class="dropdown-input border rounded bg-[var(--background-primary)] w-full h-full"
		>
			<template v-for="option in optionsArray" :key="option.value">
				<optgroup v-if="'options' in option" :label="option.label">
					<renderOption
						v-for="groupOption in option.options"
						:key="groupOption.value"
						:option="groupOption"
					/>
				</optgroup>
				<renderOption v-else :option="option" />
			</template>
		</select>
	</div>
</template>

<script lang="ts" setup>
import type { AvailableOptionTypes } from "@/composables/useOptionsToArray";
import { useOptionsMap } from "@/composables/useOptionsToArray";
import type { SelectOption } from "@/models/SelectOption";
import { computed, h } from "vue";

const props = withDefaults(
	defineProps<{
		options?: AvailableOptionTypes;
		id?: string;
		disabled?: boolean;
	}>(),
	{
		options: () => [],
		disabled: false,
	},
);

const modelValue = defineModel<string | number | boolean>();

const optionsArray = computed(() => useOptionsMap(props.options));

function renderOption(opts: {
	option: SelectOption;
	key?: string | number | symbol | boolean;
}) {
	return h(
		"option",
		{
			selected: opts.option.value === modelValue.value,
			value: opts.option.value,
			key: typeof opts.key === "boolean" ? String(opts.key) : opts.key,
		},
		opts.option.label,
	);
}
</script>
